(function() {

  angular
    .module('meanApp')
    .service('context', context);

    context.$inject = ['$rootScope', '$state', 'titleFactory'];
    function context ($rootScope, $state, titleFactory) {
        var DEFAULT_COLOR_BACKGROUND = 'salmon',
        BACK_LISTING_NAME_SUPPORTED = ['recipeWidgetNone', 'faq', 'about','contact', 'recipe','recipeInstructions', 'recipeSearchResult', 'recipeSearchStep', 'recipecreationstep'];

        this._previousState = null;
        this._currentState = null;
        this.getContextName = function() {
            return this._contextName;
        };

        this.onContextChange = function(callback) {
            this._callback = callback;
        };

        this._dispatchContextChange = function() {
            if (this._callback) {
                this._callback(this);
            }
        };  

        this.get = function() {
            return {
                href : this._href,//this variable is used to optimize SEO
                iconAction : this._iconAction,
                iconCallback : this._iconCallback,
                contextName : this._contextName,
                colorBackground : this._colorBackground,
                goBack: typeof this._goBack === 'undefined' ? true : this._goBack,
                dropDownActions: this._dropDownActions
            };
        };

        this.setPreviousState = function(previousState) {
            this._previousState = previousState;
        };

        //This computes if the current state can get a back
        this.isCurrentStateSupposedToGetBack = function() {
            var currentstateName = $state.current.name;

            return BACK_LISTING_NAME_SUPPORTED.indexOf(currentstateName) > -1;
        };

        this.getPreviousState = function() {
            return this._previousState;
        };

        this.setCurrentState = function(currentState) {
            this._currentState = currentState;
        };

        this.getCurrentState = function() {
            return this._currentState;
        };

        this.set = function(params) {
            var dispatchEvent = false;
            if(params.contextName) {
                this._contextName = params.contextName;
                dispatchEvent = true;
            }

            if(params.colorBackground) {
                this._colorBackground = params.colorBackground;
                dispatchEvent = true;
            }
            else {
                //set a default background color
                this._colorBackground = DEFAULT_COLOR_BACKGROUND;
                dispatchEvent = true;
            }

            if(params.iconAction) {
                this._iconAction = params.iconAction;
                this._dropDownActions = null;
                dispatchEvent = true;
            }
            else {
                this._iconAction = null;
                dispatchEvent = true;
            }
            
            this._href = params.goBack !== 'undefined' ? params.href : false;
            //always dispatch the event ? if yes, then remove all the other occurrences
            dispatchEvent = true;

            if(typeof params.iconCallback === 'function') {
                this._iconCallback = params.iconCallback;
                dispatchEvent = true;
                this._href = false;
            }
            else {
                this._iconCallback = null;
            }

            if(typeof params.goBack !== 'undefined') {
                console.log('reset go back to', params.goBack);
                this._goBack = params.goBack;
                dispatchEvent = true;
            }

            if(params.dropDownActions && params.dropDownActions.length > 0) {
                this._iconAction = null;
                this._dropDownActions = params.dropDownActions;
                dispatchEvent = true;
            }

            if(dispatchEvent === true) {
                console.log('dispatch context change with the following params : ', this);
                this._dispatchContextChange();
            }

            if(params.title) {
                titleFactory.setTitle(params.title+' | fraiseoubacon');
            }
            else{
                titleFactory.setTitle('Moteur de recherche de recettes et aide à la nutrition'+' | fraiseoubacon');
            }
        };

        return this;
    }

})();